import styled from "styled-components";
import { palette } from "styled-theme";

const EntityWrapper = styled.div`
  padding: 0 5px;
  .component {
    background-color: #ffffff;
    margin: 10px 5px;
    padding: 10px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
  .light-component {
    margin: 10px 5px;
  }
  .entity-content {
    height: ${(props) =>
      props["hasTabs"] ? `calc(100vh - 210px)` : `calc(100vh - 163px)`};
    overflow: auto;
  }
  .activities-content {
   height: calc(100vh - 210px);
   overflow: auto;
 }
  .ant-timeline-item {
    padding-bottom: 10px;
  }
  .custom-collapse {
    .ant-collapse-header {
      padding: 0px !important;
    }
    .ant-collapse-content {
      background: #ffffff !important;
    }
  }
   
  }
  .custom-collapse-section {
    .ant-collapse-content {
      background: #ffffff !important;
      padding: 12px 0;
    }
    &.no-space {
      .ant-collapse-content {
        padding: 0px;
        .ant-collapse-content-box {
          padding-bottom: 0px;
        }
      }
    }
    &.contacts {
      .ant-collapse-content {
        padding: 0px;
        .ant-collapse-content-box {
          padding: 0px 10px;
        }
      }
    }
    &.contact {
      .ant-collapse-header {
        padding: 8px 10px;
      }
      .ant-collapse-content {
        padding: 0px;
        .ant-collapse-content-box {
          padding: 0px 10px;
        }
      }
    }
    &.feed {
     .ant-collapse-content-box {
       padding: 4px 0 16px 0;
     }
  }
  .activity_form {
    padding: 12px;
    .collpase-form {
      .ant-collapse-header,
      .ant-collapse-content-box {
        padding: 0;
      }
     }
    .ant-form-item {
      margin-bottom: 10px;
    }
  }

  .info_detail {
    display: flex;
    flex-direction: row;
  }
  .info_detail_title {
    width: 80px;
  }
`;

export default EntityWrapper;
